import { formatDate } from "@/utils/helpers";

function formatCardDate(value: unknown): string {
  if (value == null) return "—";
  const text = String(value).trim();
  if (!text || text === "—") return "—";
  return formatDate(text) || text;
}

function pickDateValue(
  row: Record<string, unknown> | null | undefined,
  viewRow: Record<string, unknown> | null | undefined,
  keys: string[],
): string {
  for (const source of [row, viewRow]) {
    if (!source) continue;
    for (const key of keys) {
      const value = source[key];
      if (value != null && String(value).trim() && String(value).trim() !== "—") {
        return formatCardDate(value);
      }
    }
  }
  return "—";
}

type Props = {
  row?: Record<string, unknown> | null;
  viewRow?: Record<string, unknown> | null;
  className?: string;
};

export function TableRowCardDates({ row, viewRow, className = "" }: Props) {
  const createdAt = pickDateValue(row, viewRow, [
    "createdAt",
    "createdAtImpilo",
    "created_at",
  ]);
  const updatedAt = pickDateValue(row, viewRow, [
    "updatedAt",
    "updatedAtImpilo",
    "updated_at",
  ]);

  return (
    <div
      className={`text-muted-foreground flex w-full flex-wrap items-center justify-between gap-x-3 gap-y-0.5 text-sm ${className}`}
    >
      <span>Created: {createdAt}</span>
      <span>Updated: {updatedAt}</span>
    </div>
  );
}
